import {
  getAllGroupTickets,
  getGroupTickets,
  createGroupTicket,
  getGroupTicketById,
  updateGroupTicket,
  deleteGroupTicket,
  UnlinkTicket,
  LinkTicket,
  getGroupTicketDateFilter,
} from "@/http/setup/groupTicketing.js";

export default {
  namespaced: true,
  state: {
    allGroupTickets: [],
    groupTickets: [],
    groupTicketById: null,
  },
  actions: {
    async deleteGroupTicket(_, data) {
      try {
        const res = await deleteGroupTicket(data.id, data.forceDelete);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAllGroupTickets({ commit }) {
      const resp = await getAllGroupTickets();
      commit("SET_ALL_GROUP_TICKETS", resp.data);
      return resp;
    },
    async getOrderGroupTicketDateFilterAction({ commit }, data) {
      try {
        const resp = await getGroupTicketDateFilter(data);
        commit("SET_GROUP_TICKET_DATE_FILTER", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getGroupTickets({ commit }, payload) {
      const resp = await getGroupTickets(payload);
      commit("SET_GROUP_TICKETS", resp.data);
      return resp;
    },
    async createGroupTicket(_, payload) {
      const resp = await createGroupTicket(payload);
      return resp;
    },
    async getGroupTicketById({ commit }, id) {
      const resp = await getGroupTicketById(id);
      commit("SET_GROUP_TICKET_BY_ID", resp.data);
      return resp.data;
    },
    async updateGroupTicket(_, { id, payload }) {
      const resp = await updateGroupTicket(id, payload);
      return resp;
    },
    async UnlinkTicket(_, { id, payload }) {
      const resp = await UnlinkTicket(id, payload);
      return resp;
    },
    async LinkTicket(_, { id, payload }) {
      const resp = await LinkTicket(id, payload);
      return resp;
    },
  },
  mutations: {
    SET_ALL_GROUP_TICKETS(state, payload) {
      state.allGroupTickets = payload;
    },
    SET_GROUP_TICKETS(state, payload) {
      state.groupTickets = payload;
    },
    SET_GROUP_TICKET_BY_ID(state, payload) {
      state.groupTicketById = payload;
    },
    SET_GROUP_TICKET_DATE_FILTER(state, payload) {
      state.allGroupTickets = payload;
    },
  },
};
